/**
 * Option lists shared by the league create and edit forms.
 *
 * Skill levels: the scale shared with tournaments and drop-ins, which the
 * database accepts (leagues_skill_level_check, LG-B17). Before, the form
 * offered levels the database refused with a 500.
 */
export const SKILL_LEVEL_OPTIONS = Object.freeze([
  { value: 'beginner', label: '🌿 Beginner' },
  { value: 'recreational', label: '🌱 Recreational' },
  { value: 'intermediate', label: '⚡ Intermediate' },
  { value: 'advanced', label: '🔥 Advanced' },
  { value: 'professional', label: '👑 Professional' },
]);

/** Legacy league values, mapped onto the shared scale. */
export const SKILL_LEVEL_ALIASES = Object.freeze({
  competitive: 'advanced',
  elite: 'professional',
});

export const normalizeSkillLevel = (value) => SKILL_LEVEL_ALIASES[value] || value || '';
